module.exports = __webpack_public_path__ + "static/img/gzh.c481807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/gzh.jpg
// module id = Mf1g
// module chunks = 1